import { withInstall } from '@ll-plus/utils'

import Cascader from './src/cascader.vue'

export const LlCascader = withInstall(Cascader)
export default LlCascader
export * from './src/cascader'

declare module 'vue' {
  export interface GlobalComponents {
    LlCascader: typeof Cascader
  }
}
